import angular from 'angular'

import sale from './sale/sale.module'

import scrappingMenu from './scrapping.menu'
import scrappingRoutes from './scrapping.routes'
import scrappingRun from './scrapping.run'

const name = 'routingScrapping'

angular.module(name, [
  sale,
])
  .factory('scrappingMenu', scrappingMenu)
  .config(scrappingRoutes)
  .run(scrappingRun)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/scrapping/scrapping.module.js